import Http from "../../../../../core/http-axios-react/http/Http";
import { HttpBaseRequest } from "../../../../../core/HttpRequest";
import { HttpBaseResponse, HttpData } from "../../../../../core/HttpResponse";
import {
  Form_Create_PaymentMethod,
  Form_Update_PaymentMethod,
} from "../../../form/paymentMethod/Form";
import { M_PaymentMethod } from "../../../type/Invoice.type";

export const get = async ({ keyword, page, perPage }: HttpBaseRequest) => {
  const results = await Http.get<HttpBaseResponse<HttpData<M_PaymentMethod[]>>>(
    {
      url: "/invoice/payment_method",
      params: {
        keyword,
        page,
        perPage,
      },
    }
  );
  return results;
};

export const gets = async ({
  payment_method_id,
}: {
  payment_method_id?: string;
}) => {
  const results = await Http.get<HttpBaseResponse<M_PaymentMethod>>({
    url: "/invoice/payment_method/detail",
    params: {
      payment_method_id,
    },
  });
  return results;
};

export const add = async ({
  payment_method_name,
}: Form_Create_PaymentMethod) => {
  const results = await Http.post({
    url: "/invoice/payment_method/insert",
    data: {
      payment_method_name,
    },
  });
  return results;
};

export const update = async ({
  payment_method_id,
  payment_method_name,
}: Form_Update_PaymentMethod) => {
  const results = await Http.post({
    url: "/invoice/payment_method/update",
    data: {
      payment_method_id,
      payment_method_name,
    },
  });
  return results;
};
